import React from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

// import FeatureDescription from "../../../../visComponents/featureDescription";
import FeatureName from "../../../../visComponents/featureName";

import SvgIcon from "@mui/material/SvgIcon";
import {GroheLockIcon} from "../../../../common/icons";
import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import {setLookOverlayOpened} from "../../../../../actions/lookFunctions";
import {LOOK_OVERLAYS} from "../../../core/constants";
import {IS_PRODUCT_JOURNEY} from "../../../../../config";


const GroheFeatureLockedBadge = (props) => {

  const {lookActiveFeature, setLookOverlayOpened} = props;

  if (!lookActiveFeature) {
    return null
  }

  const lockedButtonClick = () => {
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeatureLockedBadge);
    setLookOverlayOpened(LOOK_OVERLAYS.leadCapture);
  }

  return (
    <div className={"grohe-locked" + (IS_PRODUCT_JOURNEY ? "" : " grohe-locked--look")} onClick={lockedButtonClick}>
      <div className="grohe-locked__icon">
        <SvgIcon fontSize={"inherit"}>
          <GroheLockIcon className="lm-locked__icon"/>
        </SvgIcon>
      </div>
      <div className="grohe-locked__content">
        <h2 className="lk-title__text bold lk-title__text--locked">
          <FeatureName feature={lookActiveFeature} useCollectionName={true}/>
        </h2>
        {/*{lookActiveFeature.dbFeature.sku ? (*/}
        {/*  <p className="lm-feature__content-model">*/}
        {/*    <LookFeatureSku lookFeature={lookActiveFeature}/>
        {/*  </p>*/}
        {/*) : null}*/}
        {/*{lookActiveFeature.dbFeature.description ? (*/}
        {/*  <div className="lm-feature__content-description lm-feature__content-description--locked">*/}
        {/*    <FeatureDescription feature={lookActiveFeature} brief={true}/>*/}
        {/*  </div>*/}
        {/*) : null}*/}
        <div className="lm-feature__content-description lm-feature__content-description--locked">
          <FeatureName feature={lookActiveFeature} maxLength={40}/>
        </div>
        <p className="grohe-locked__content-text bold">
          <FormattedMessage id="grohe.feature.productLocked"/>
        </p>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {lookActiveFeature} = store.lookState;

  return {
    lookActiveFeature,
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened,
};

export default connect(mapStateToProps, mapDispatchToProps)(GroheFeatureLockedBadge)
